'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dPush$002dNotification from "./app.api.-General-Practice-App-Update$-Push-Notification.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ as $c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ };
$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$PushNotification$() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ as $h_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ };
$h_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype.toString__T = (function() {
  return "PushNotification";
});
$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$PushNotification = (function(x$0) {
  var data$3 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dPush$002dNotification.$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification(data$3);
});
$c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$PushNotification(p);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$, "app.api.GeneralPracticeAppUpdate$PushNotification$", ({
  Lapp_api_GeneralPracticeAppUpdate$PushNotification$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ as $d_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ };
var $n_Lapp_api_GeneralPracticeAppUpdate$PushNotification$;
function $m_Lapp_api_GeneralPracticeAppUpdate$PushNotification$() {
  if ((!$n_Lapp_api_GeneralPracticeAppUpdate$PushNotification$)) {
    $n_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ = new $c_Lapp_api_GeneralPracticeAppUpdate$PushNotification$();
  }
  return $n_Lapp_api_GeneralPracticeAppUpdate$PushNotification$;
}
export { $m_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ as $m_Lapp_api_GeneralPracticeAppUpdate$PushNotification$ };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-Push-Notification$.js.map
